export default [
	{
		original: "./images/fullsize/90.jpg",
		thumbnail: "./images/thumbnails/90.jpg"
	},
	{
		original: "./images/fullsize/89.jpg",
		thumbnail: "./images/thumbnails/89.jpg"
	},
	{
		original: "./images/fullsize/91.jpg",
		thumbnail: "./images/thumbnails/91.jpg"
	},
	{
		original: "./images/fullsize/92.jpg",
		thumbnail: "./images/thumbnails/92.jpg"
	},
	{
		original: "./images/fullsize/25.jpg",
		thumbnail: "./images/thumbnails/25.jpg"
	},
	{
		original: "./images/fullsize/27.jpg",
		thumbnail: "./images/thumbnails/27.jpg"
	},
	{
		original: "./images/fullsize/28.jpg",
		thumbnail: "./images/thumbnails/28.jpg"
	},
	{
		original: "./images/fullsize/29.jpg",
		thumbnail: "./images/thumbnails/29.jpg"
	},
	// {
	// 	original: "./images/fullsize/30.jpg",
	// 	thumbnail: "./images/thumbnails/30.jpg"
	// },
	{
		original: "./images/fullsize/31.jpg",
		thumbnail: "./images/thumbnails/31.jpg"
	},
	{
		original: "./images/fullsize/32.jpg",
		thumbnail: "./images/thumbnails/32.jpg"
	},
	{
		original: "./images/fullsize/34.jpg",
		thumbnail: "./images/thumbnails/34.jpg"
	},
	{
		original: "./images/fullsize/55.jpg",
		thumbnail: "./images/thumbnails/55.jpg"
	},
	{
		original: "./images/fullsize/60.jpg",
		thumbnail: "./images/thumbnails/60.jpg"
	},
	{
		original: "./images/fullsize/61.jpg",
		thumbnail: "./images/thumbnails/61.jpg"
	},
	{
		original: "./images/fullsize/65.jpg",
		thumbnail: "./images/thumbnails/65.jpg"
	},
	{
		original: "./images/fullsize/79.jpg",
		thumbnail: "./images/thumbnails/79.jpg"
	},
	{
		original: "./images/fullsize/80.jpg",
		thumbnail: "./images/thumbnails/80.jpg"
	},
	{
		original: "./images/fullsize/83.jpg",
		thumbnail: "./images/thumbnails/83.jpg"
	},
	{
		original: "./images/fullsize/93.jpg",
		thumbnail: "./images/thumbnails/93.jpg"
	},
	{
		original: "./images/fullsize/94.jpg",
		thumbnail: "./images/thumbnails/94.jpg"
	},
	{
		original: "./images/fullsize/95.jpg",
		thumbnail: "./images/thumbnails/95.jpg"
	}
]



// WEBPACK FOOTER //
// ./src/images.js